<template>
  <div>
    <div v-if="list && list.length > 0">
      <el-image
        :style="{
          width: size,
          height: size,
          'margin-right': '10px',
          'border-radius': '5px',
          border: '1px solid var(--fm-border-color)',
        }"
        fit="cover"
        :preview-src-list="list.map((d) => d.sysFile.prefix + d.sysFile.name)"
        :initial-index="index"
        :src="item.sysFile.prefix + item.sysFile.name"
        v-for="(item, index) in list"
        :key="index"
      ></el-image>
    </div>
    <span v-fmtype="'warning'" v-else>未上传{{ name }}</span>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebOrderImageList",
  props: {
    list: { type: Array },
    size: {
      type: [String, Number],
      default: "80px",
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/fm/OrderImageList.vue